/* The Blu Tulip — theme.js */

(function() {
  /* Nav hamburger */
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobileNav');
  const closeBtn = document.getElementById('mobileNavClose');
  if (hamburger && mobileNav) {
    function openNav() {
      mobileNav.classList.add('open');
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      mobileNav.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    hamburger.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    mobileNav.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', closeNav); });
  }

  /* Fade-up observer */
  (function() {
    const obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-up').forEach(function(el, i) {
      el.style.transitionDelay = (i % 4 * 0.1) + 's';
      obs.observe(el);
    });
  })();

  /* Sticky nav scroll (home page only) */
  const nav = document.getElementById('siteNav');
  if (nav && nav.classList.contains('site-nav--home')) {
    setTimeout(function() { nav.classList.add('nav-ready'); }, 1600);
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 80);
    }, { passive: true });
  }
})();

/* Postcode checker (delivery page) */
var DELIVERY_ZONES = {
  '5000':{ zone:'Adelaide', fee:'$25', note:'Same-day available · order before 11am' },
  '5006':{ zone:'North Adelaide', fee:'$25', note:'Same-day available · order before 11am' },
  '5007':{ zone:'Bowden / West Croydon', fee:'$20', note:'Same-day available · order before 11am' },
  '5008':{ zone:'Croydon / Croydon Park', fee:'$22', note:'Same-day available · order before 11am' },
  '5009':{ zone:'Allenby Gardens / Beverley', fee:'$18', note:'Same-day available · order before 11am' },
  '5010':{ zone:'Ferryden Park / Regency Park', fee:'$20', note:'Same-day available · order before 11am' },
  '5011':{ zone:'St Clair / Woodville', fee:'$16', note:'Same-day available · order before 11am' },
  '5012':{ zone:'Athol Park / Mansfield Park', fee:'$20', note:'Same-day available · order before 11am' },
  '5013':{ zone:'Gillman / Rosewater / Pennington', fee:'$22', note:'Same-day available · order before 11am' },
  '5014':{ zone:'Albert Park / Royal Park / Queenstown', fee:'$16', note:'Same-day available · order before 11am' },
  '5015':{ zone:'Port Adelaide / Birkenhead', fee:'$20', note:'Same-day available · order before 11am' },
  '5016':{ zone:'Largs Bay / Largs North', fee:'$25', note:'Same-day available · order before 11am' },
  '5017':{ zone:'Taperoo', fee:'$25', note:'Same-day available · order before 11am' },
  '5019':{ zone:'Semaphore / Exeter', fee:'$20', note:'Same-day available · order before 11am' },
  '5020':{ zone:'West Lakes Shore', fee:'$16', note:'Same-day available · order before 11am' },
  '5021':{ zone:'West Lakes', fee:'$16', note:'Same-day available · order before 11am' },
  '5022':{ zone:'Grange / Henley Beach', fee:'$10', note:'Same-day available · order before 11am' },
  '5023':{ zone:'Findon / Seaton', fee:'$14', note:'Same-day available · order before 11am' },
  '5024':{ zone:'Fulham / West Beach', fee:'$16', note:'Same-day available · order before 11am' },
  '5025':{ zone:'Flinders Park / Kidman Park', fee:'$15', note:'Same-day available · order before 11am' },
  '5031':{ zone:'Mile End / Thebarton / Torrensville', fee:'$20', note:'Same-day available · order before 11am' },
  '5032':{ zone:'Lockleys / Underdale', fee:'$18', note:'Same-day available · order before 11am' },
  '5033':{ zone:'Hilton / Marleston / Richmond', fee:'$22', note:'Same-day available · order before 11am' },
  '5034':{ zone:'Clarence Park / Goodwood / Wayville', fee:'$25', note:'Same-day available · order before 11am' },
  '5035':{ zone:'Ashford / Forestville / Keswick', fee:'$25', note:'Same-day available · order before 11am' },
  '5037':{ zone:'Glandore / Kurralta Park / Netley', fee:'$25', note:'Same-day available · order before 11am' },
  '5038':{ zone:'Plympton / Camden Park', fee:'$25', note:'Same-day available · order before 11am' },
  '5040':{ zone:'Novar Gardens', fee:'$22', note:'Same-day available · order before 11am' },
  '5043':{ zone:'Ascot Park / Morphetville', fee:'$25', note:'Same-day available · order before 11am' },
  '5044':{ zone:'Glengowrie / Somerton Park', fee:'$25', note:'Same-day available · order before 11am' },
  '5045':{ zone:'Glenelg', fee:'$25', note:'Same-day available · order before 11am' },
  '5046':{ zone:'Warradale', fee:'$25', note:'Same-day available · order before 11am' },
  '5073':{ zone:'Tranmere', fee:'$20', note:'Same-day available · order before 11am' },
  '5081':{ zone:'Medindie', fee:'$25', note:'Same-day available · order before 11am' },
  '5082':{ zone:'Fitzroy / Thorngate', fee:'$25', note:'Same-day available · order before 11am' },
  '5083':{ zone:'Nailsworth', fee:'$25', note:'Same-day available · order before 11am' },
  '5084':{ zone:'Kilburn', fee:'$25', note:'Same-day available · order before 11am' },
  '5950':{ zone:'Adelaide Airport', fee:'$20', note:'Same-day available · order before 11am' }
};

function checkPostcode() {
  var input = document.getElementById('postcodeInput');
  var result = document.getElementById('postcodeResult');
  if (!input || !result) return;
  var pc = input.value.trim();
  if (!/^\d{4}$/.test(pc)) {
    result.innerHTML = '<p class="postcode-msg postcode-msg--warn">Please enter a valid 4-digit postcode.</p>';
    return;
  }
  var zone = DELIVERY_ZONES[pc];
  if (zone) {
    result.innerHTML =
      '<div class="postcode-hit">' +
        '<span class="postcode-zone">' + zone.zone + '</span>' +
        '<p class="postcode-fee">' + zone.fee + ' delivery</p>' +
        '<p class="postcode-note">' + zone.note + '</p>' +
      '</div>';
  } else {
    result.innerHTML =
      '<p class="postcode-msg postcode-msg--outside">' +
        'Outside our standard delivery area — give us a call on ' +
        '<a href="tel:0883550204">08 8355 0204</a> and we\'ll see what we can do.' +
      '</p>';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var postcodeInput = document.getElementById('postcodeInput');
  if (postcodeInput) postcodeInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkPostcode(); });
});
